import { baseAxios } from "config";

/**
 * Generates a filled PDF for an applicant and attaches it to their record
 * @param {string} formId - The ID of the form
 * @param {string} applicantId - The ID of the applicant
 * @param {object} formValues - The values to fill in the form
 * @param {string} outsideMode - The outside mode (protected, public, etc.)
 * @returns {Promise} - The API response with attachment data
 */
const generateFilledPdfForApplicant = async ({ formId, applicantId, formValues, outsideMode }) => {
  try {
    const outsideModeQuery = !outsideMode ? "" : `outside-${outsideMode}/`;

    const response = await baseAxios.post(`/${outsideModeQuery}llm/dynamicForms/applicant/generate-pdf`,
      { formId, applicantId, formValues }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default generateFilledPdfForApplicant;
